import React, { useEffect, useState } from 'react';
import MerchCard from '../components/MerchCard';
import { API_URL } from '../config';
import '../styles/Home.css';

interface MerchItem {
  id: string;
  name: string;
  price: number;
  description: string;
  image: string;
}

const Merchandise: React.FC = () => {
  const [items, setItems] = useState<MerchItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/merchandise`)
      .then(res => res.json())
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching merchandise:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="home-container">
        <div className="loading-state">Loading merchandise...</div>
      </div>
    );
  }

  return (
    <div className="home-container">
      <div style={{ 
        background: 'linear-gradient(135deg, #6e8efb, #a777e3)', 
        color: 'white', 
        padding: '20px', 
        borderRadius: '15px', 
        marginBottom: '30px', 
        textAlign: 'center',
        boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ margin: '0 0 10px 0' }}>🚚 Sunday is Delivery Day!</h2>
        <p style={{ margin: 0, opacity: 0.9 }}>
          Get <strong>FREE SHIPPING</strong> on all orders delivered this Sunday. 
          <br/>
          <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>⚠️ Must order by Wednesday for free delivery!</span>
          <br/>
          Missed the cutoff? You can still pick your own delivery day for a small fee.
        </p>
      </div>

      <h1 style={{ textAlign: 'center', marginBottom: '30px', color: 'var(--primary-color)' }}>Sitter Shopping</h1>
      <div className="app-grid">
        {items.map(item => (
          <MerchCard key={item.id} {...item} />
        ))}
      </div>
    </div>
  );
};

export default Merchandise;
